import { Modal, H2, H3 } from '@manulife/mux';
import { useHistory } from 'react-router-dom';
import useShallowEqualSelector from '../../CustomHooks/useShallowEqualSelector';
import useAEMContent, { FRAGMENT_MP } from '../../CustomHooks/useAEMContent';
import WhoIsEligibleLoadingIndicator from '../LoadingIndicator/WhoIsEligibleLoadingIndicator';

const WhoIsEligible = () => {
    const { isLoadingAEMData, isLoadingMemberData, member } = useShallowEqualSelector((state) => ({
        isLoadingAEMData: state.AEMContent.isLoading,
        isLoadingMemberData: state.MemberData.isLoadingMemberData,
        member: state.MemberData.member,
    }));

    const history = useHistory();

    const headingOne = useAEMContent(FRAGMENT_MP.whoIsCovered, 'headingOne');
    const descriptionOne = useAEMContent(FRAGMENT_MP.whoIsCovered, 'descriptionOne', { parseHTML: true });
    const headingTwo = useAEMContent(FRAGMENT_MP.whoIsCovered, 'headingTwo');
    const descriptionTwo = useAEMContent(FRAGMENT_MP.whoIsCovered, 'descriptionTwo', { parseHTML: true });
    const headingThree = useAEMContent(FRAGMENT_MP.whoIsCovered, 'headingThree');
    const descriptionThree = useAEMContent(FRAGMENT_MP.whoIsCovered, 'descriptionThree', { parseHTML: true });
    const headingFour = useAEMContent(FRAGMENT_MP.whoIsCovered, 'headingFour');
    const descriptionFour = useAEMContent(FRAGMENT_MP.whoIsCovered, 'descriptionFour', {
        replaceText: [
            {
                key: '{maxAge}',
                value: member.plan?.studentMaxAge,
            },
        ],
        parseHTML: true,
    });
    const headingFive = useAEMContent(FRAGMENT_MP.whoIsCovered, 'headingFive');
    const descriptionFive = useAEMContent(FRAGMENT_MP.whoIsCovered, 'descriptionFive', { parseHTML: true });

    const isDataLoading = isLoadingMemberData || isLoadingAEMData;

    return (
        <Modal ariaLabelledBy="heading" isOpen={true} onClose={() => history.push('/gb/member-profile-2/family')}>
            {isDataLoading && <WhoIsEligibleLoadingIndicator data-testid="whoIsEligibleLoadingIndicator" />}
            {!isDataLoading && (
                <div>
                    <H2 id="heading" customStyle={{ elementStyle: { marginTop: '0' } }}>
                        {headingOne}
                    </H2>
                    {descriptionOne}
                    <H3>{headingTwo}</H3>
                    {descriptionTwo}
                    <H3>{headingThree}</H3>
                    {descriptionThree}
                    <H3>{headingFour}</H3>
                    {descriptionFour}
                    <H3>{headingFive}</H3>
                    {descriptionFive}
                </div>
            )}
        </Modal>
    );
};

export default WhoIsEligible;
